export default __webpack_public_path__ + "static/media/icon-node.80b44efb.svg";